import { useQuery } from '@tanstack/react-query';

import { PluginEquifaxPpsrRegistrationFormResponse } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runEquifaxPpsrRegistrationForm } from '../../requests/runEquifaxPpsrRegistrationForm';

export const useEquifaxPpsrRegistrationForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<PluginEquifaxPpsrRegistrationFormResponse> | undefined
  >({
    queryKey: [
      PLUGIN_BASE_PATH,
      'equifax-ppsr-registration-form',
      applicationUuid,
    ],
    queryFn: () =>
      runEquifaxPpsrRegistrationForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
